import { ref } from '@vue/composition-api'
import store from '@/store'
import {
  SET_IS_TOOLKIT_FOR_WALLET_REFERRALS,
  SET_SHOULD_DISPLAY_TOOLKIT_POPUP,
} from '@/store/modules/toolkit.module'
import { HELP_URL } from '@/constants'

export function useDashboardReferral() {
  const isModalOpen = ref(false)
  const helpUrl = HELP_URL()

  function openModal() {
    isModalOpen.value = true
  }

  function closeModal() {
    isModalOpen.value = false
  }

  function navigateToReferrals(router) {
    store.commit(SET_SHOULD_DISPLAY_TOOLKIT_POPUP, true)
    store.commit(SET_IS_TOOLKIT_FOR_WALLET_REFERRALS, true)
    router.push({ name: 'referrals' })
  }

  return {
    isModalOpen,
    helpUrl,
    openModal,
    closeModal,
    navigateToReferrals,
  }
}
